module.exports = __webpack_public_path__ + "img/poster2-main.70e4ac94.png";